import { render, staticRenderFns } from "./StageTile.vue?vue&type=template&id=27eb99e0&scoped=true&lang=pug&"
import script from "./StageTile.vue?vue&type=script&lang=js&"
export * from "./StageTile.vue?vue&type=script&lang=js&"
import style0 from "./StageTile.vue?vue&type=style&index=0&id=27eb99e0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27eb99e0",
  null
  
)

export default component.exports